import StationMarks from './StationMarks';

const StationMarksRoutes = {
  path: 'stationmarks',
  name: 'devices.devices_sensors',
  component: StationMarks,
  meta: {
    prefix_permission: 'devices_stationmarks',
  },
};

export default StationMarksRoutes;
